// src/services/api.js

import axios from 'axios';
import { API_BASE_URL } from './config';
import { fromApiData } from './caseTransform';

function extractApiErrorMessage(error) {
  const data = error?.response?.data;

  if (typeof data === 'string' && data.trim()) {
    return data.trim();
  }

  if (data?.detail && data?.message) {
    return `${data.message} ${data.detail}`.trim();
  }

  if (data?.message) {
    return data.message;
  }

  if (data?.title) {
    return data.title;
  }

  return error?.message || 'Request failed.';
}

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Ensure token is stored
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    response.data = fromApiData(response.data);
    return response;
  },
  (error) => {
    if (error?.response?.data) {
      error.response.data = fromApiData(error.response.data);
    }

    error.friendlyMessage = extractApiErrorMessage(error);

    return Promise.reject(error);
  }
);

export default api;
